import { Action, createReducer, on } from "@ngrx/store"
import * as ProductFamilyActionTypes from "../../actions/productFamilies/productFamilies.actions";

export interface ProductFamilyState {
    isLoading: boolean;
    created: boolean;
    productFamily: any;
    productFamilyList: any[];
    productFamilyExcelList: any[];
    productFamilyTotal: number;
}

export const initialState: ProductFamilyState = {
    isLoading: false,
    created: false,
    productFamily: null,
    productFamilyExcelList: null,
    productFamilyList: null,
    productFamilyTotal: null,
}

const productFamilyReducer = createReducer(
    initialState,
    on(
        ProductFamilyActionTypes.getProductFamiliesList,
        (state, { options }) =>
          ({
            ...state,
            error: null,
            options: options,
            isLoading: true,
          } as ProductFamilyState)
      ),
      on(ProductFamilyActionTypes.loadProductFamiliesList, (state, { response }) => {
        return {
          ...state,
          productFamilyList: (response as any)?.result?.items
            ? (response as any)?.result?.items
            : undefined,
          isLoading: false,
          error: null,
          productFamilyTotal: (response as any)?.result?.size
            ? (response as any)?.result?.size
            : 0,
        };
      }),
      on(
        ProductFamilyActionTypes.getProductFamily,
        (state, { code }) =>
          ({
            ...state,
            error: null,
            code: code,
            created: false,
            isLoading: true,
          } as ProductFamilyState)
      ),
      on(ProductFamilyActionTypes.loadProductFamily, (state, { response }) => {
        return {
          ...state,
          productFamily: (response as any).result ? (response as any).result : undefined,
          isLoading: false,
          error: null,
        };
      }),
      on(ProductFamilyActionTypes.resetProductFamily, (state) => {
        return {
          ...state,
          productFamily: null,
          error: null,
        };
      }),
      on(ProductFamilyActionTypes.createProductFamily, (state) => {
        return {
          ...state,
         isLoading: true,
        }
      }),
      on(ProductFamilyActionTypes.resetCreation, (state) => {
        return {
          ...state,
          created: true,
        };
      }),
      on(ProductFamilyActionTypes.updateProductFamily, (state) => {
        return {
          ...state,
          isLoading: true,
        }
      })
)

export function reducer(state: ProductFamilyState | undefined, action: Action) {
    return productFamilyReducer(state, action);
  }
